import {
  SUMMARY_TIME_FETCHING,
  SUMMARY_TIME_FAILED,
  SUMMARY_TIME_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SUMMARY_TIME_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case SUMMARY_TIME_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case SUMMARY_TIME_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
